jQuery(document).ready(function ($) {

    const cookieName = 'announcement_banner_dismissed';

    function getCookie(name) {
        const match = document.cookie.match(new RegExp('(^|; )' + name + '=([^;]*)'));

        return match ? decodeURIComponent(match[2]) : null;
    }

    function setCookie(name, value, days) {
        const date = new Date();

        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));

        document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + date.toUTCString() + '; path=/';
    }

    function deleteCookie(name) {
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
    }

    const $banner = $('.announcement-banner');

    if (!$banner.length) {
        return;
    }

    const bannerText = $banner.find('.announcement-banner__text').text().trim();
    const dismissedText = getCookie(cookieName);

    if (dismissedText === bannerText) {
        $banner.hide();
    } else {
        $('body').addClass('has-announcement-banner');

        if (dismissedText !== null) {
            deleteCookie(cookieName);
        }
    }

    $('.announcement-banner__close').on('click', function (event) {
        event.preventDefault();

        const days = parseInt($banner.data('expiration-days'), 10) || 1;

        setCookie(cookieName, bannerText, days);

        $('body').removeClass('has-announcement-banner');

        $banner.slideUp(500);
    });
});